import { matchPath } from 'react-router-dom';

/** What the clinic selector calls the view spanning every accessible clinic. */
export const ALL_LOCATIONS_LABEL = 'All locations';

// Every other page shows the active clinic, so a page missing from this list
// can never show one clinic's data under the All locations label.
const ALL_LOCATIONS_ROUTES = [
  '/referrals',
  '/referrals/:id/view',
  '/referrals/:id/inbound',
];

/** Whether the page at `pathname` can show every location at once. */
export const supportsAllLocations = (pathname: string) =>
  ALL_LOCATIONS_ROUTES.some(pattern => matchPath(pattern, pathname));
